import * as constants from './constants';
import {post} from "../../../utils/request";
import {MEMBER_RECHARGE} from '../../../utils/api';


export const userRecharge = (params) => {
    return async (dispatch) => {
        const result = await post(MEMBER_RECHARGE, params);
        return result;
    }
};

